import {
    formatPhoneNational,
    toE164,
    isValidPhone,
    phoneDigits,
} from '../helpers/phone';

export default {
    computed: {
        placeCountry() {
            const place = this.$store && this.$store.state ? this.$store.state.place : null;
            return place && place.country_code ? place.country_code : 'BR';
        },
    },
    methods: {
        formatPhone(value, country = null) {
            return formatPhoneNational(value, country || this.placeCountry);
        },
        toE164(value, country = null) {
            return toE164(value, country || this.placeCountry);
        },
        isValidPhone(value, country = null) {
            return isValidPhone(value, country || this.placeCountry);
        },
        phoneDigits(value, country = null) {
            return phoneDigits(value, country || this.placeCountry);
        },
    },
};
